import { useState } from 'react';
import QualificationAppel from '../../QualificationAppel';

/**
 * Widget wrapper for QualificationAppel (Nouveau Lead)
 * Renders the lead creation form in standalone/embedded mode.
 */
export default function NouveauLeadWidget({ societeId, embedded = false }) {
  const [leadCreated, setLeadCreated] = useState(null);

  const handleLeadCreated = (clientData) => {
    setLeadCreated(clientData);
  };

  if (leadCreated) {
    return (
      <div className="bg-slate-900 rounded-xl p-8 text-center">
        <div className="w-16 h-16 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
        </div>
        <h3 className="text-lg font-bold text-white mb-2">Lead cree avec succes !</h3>
        <p className="text-sm text-slate-400 mb-4">
          {leadCreated.nom} {leadCreated.prenom} — {leadCreated.telephone}
        </p>
        <button
          onClick={() => setLeadCreated(null)}
          className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 text-white rounded-lg text-sm font-medium transition-colors"
        >
          Creer un autre lead
        </button>
      </div>
    );
  }

  return (
    <div className={embedded ? '' : ''}>
      <QualificationAppel
        isOpen={true}
        onClose={() => {}}
        authUser={null}
        onLeadCreated={handleLeadCreated}
        onOpenClientFiche={() => {}}
        embedded={true}
        societeId={societeId}
      />
    </div>
  );
}
